//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import MetaTags from 'react-meta-tags';
import axios from 'axios';
import { AUcallout } from '@gov.au/callout';
import { useHistory } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';
import RPADetails from '../components/Portal/RPADetails';
import Container from '../components/CASA/Container';
import CASASpinner from '../components/Portal/CASASpinner';

//Actions
import { getPortalUrl, isUUID, getUserHomePage, getParamValue, urlSearchValue } from '../components/Portal/Utilities';
import { getExpirySelector, getUrlSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getOrganisationDetails, FETCH_ORGANISATIONDETAILS_SUCCESS } from '../PortalStore/Actions/OrganisationDetailsActions';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';

export const SingleRPAPage = () => {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let history = useHistory();
    let dispatch = useDispatch();

    let rpa = JSON.parse(atob(decodeURIComponent(urlSearchValue('rpa'))));


    let from = getParamValue('from');
    let organisationId = urlSearchValue('casaorgid');
    if (organisationId === null) {
        organisationId = getParamValue('organisationId');
    }
    if (!organisationId) {
        organisationId = "";
    }
    let userdetails = useSelector(state => state.userdetails);
    let organisationdetails = useSelector(state => state.organisationDetails);
    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let appsIndividual = useSelector(state => state.appsIndividual); //undefined
    let appsOrganisation = useSelector(state => state.applsOrganisation);
    let draftRPAsIndividual = useSelector(state => state.draftsIndividual.items.draftRPAs); 
    let draftRPAsOrganisation = useSelector(state => state.draftsOrganisation.items.draftRPAs);
    
    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));

    let snippetR = useSelector(state => getSnippetSelector(state, "CASA - Drone Foreign Registration"));

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    useEffect(() => { 
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accesstoken = B2CSettings.items.accesstokenPortal;

        setPageLoading(true);

        axios.all([
            dispatch(getOrganisationDetails(webappurl, accesstoken, organisationId)),
        ])
            .then(axios.spread((orgsres) => {
                if (orgsres.type === FETCH_ORGANISATIONDETAILS_SUCCESS) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("OD.1");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: OD.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("OD.2");
                setPageLoading(false);
                setPageLoaded(true);

                let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                let details = "Details: OD.2";
                dispatch(addPageAlert({ level: "error", title: msg, message: details }));
            });

        
    }, []);

    if (organisationId.length < 36) {
        organisationId = "";
    }

    // prevent access if no orgid or invalid organisationId or organisationId not related to user or no rpaid
    if (!isUUID(rpa.droneRegistrationId) && from === 'org') {
        history.push("/error?code=RPA.2&standalone=" + standalone);
    }

    if (organisationId === "" && from === 'org') {
        history.push("/error?code=ORG.1&standalone=" + standalone);
    }
    if (rpa === "") {
        history.push("/error?code=ORG.2&standalone=" + standalone);
    }

    if (participants && participants.items && !participants.items.isParticipant && from === 'org') {
        history.push("/error?code=ORG.3&standalone=" + standalone);
    }

    if (organisationdetails && organisationdetails.items && organisationdetails.value && organisationdetails.items.value.length === 0 && from === 'org') {
        history.push("/error?code=RPA.1&standalone=" + standalone);
    }

    if (!isUUID(organisationId) && from === 'org') {
        history.push("/error?code=ORG.4&standalone=" + standalone);
    }

    let items = [];
    let showItems = false;

    let jparams = {
        from: from,
        organisationId: organisationId
    }
    if (from === "ind") {
        let item = {
            link: getPortalUrl("/dashind", standalone, urlHome) + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
            text: 'myCASA'
        }
        items.push(item);
        item = {
            link: getPortalUrl("/indmanagerpa", standalone, "/forms") + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
            text: 'Manage registered drones'
        }
        items.push(item);
        item = {
            text: 'Drone details'
        }
        items.push(item);
    }
    else {
        let item = {
            link: getPortalUrl("/dashorg", standalone, urlHome) + "&casaorgid=" + organisationId + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
            text: 'myCASA'
        }
        items.push(item);
        item = {
            link: getPortalUrl("/orgmanagerpa", standalone, "/forms") + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
            text: 'Manage registered drones'
        }
        items.push(item);
        item = {
            text: 'Drone details'
        }
        items.push(item);
    }
    showItems = true;

    let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
    let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');
    let todayStart = moment().startOf('day');

    let msg = '';
    let msglevel = '';

    let validUntilEnd = moment(rpa.expirydate, "DD MMM YYYY").endOf('day');
    let validUntilStart = moment(rpa.expirydate, "DD MMM YYYY").startOf('day');

    if (validUntilEnd < todayStart && expiredRPA < validUntilStart) {
        // expired
        msg = 'Expired';
        msglevel = 'error';
    }
    if (expiringRPA >= validUntilStart && validUntilStart >= todayStart) {
        // expiring
        msg = 'Expiring soon';
        msglevel = 'warning';
    }

    const loc = getPortalUrl("/" + userHomePage, standalone, urlHome);

    if (!pageLoaded) {
        return (
            <Fragment>
                <MetaTags>
                    <title>Manage Registered Drones (Organisation)</title>
                </MetaTags>

                <Container show={true}>

                    <CASASpinner message="Working. Please wait....." />

                </Container>

            </Fragment>
        )
    }
    else {
        return (
            <Fragment>
                <MetaTags>
                    <title>Manage Registered Drone</title>
                </MetaTags>

                <Heading
                    id="inddronedetails"
                    text="Drone details"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={true} />

                <RPADetails
                    droneId={rpa.droneid}
                    droneRegId={rpa.droneRegistrationId}
                    drone={rpa}
                    organisationId={organisationId}
                    expiryMsg={msg}
                    from={from}
                    B2CSettings={B2CSettings}
                    apps={from === 'org' ? appsOrganisation : appsIndividual}
                    draftRPAs={from === 'org' ? draftRPAsOrganisation : draftRPAsIndividual}
                />

                {rpa.isregisteredoverseas === "Yes" ?
                    <div>
                        <AUcallout
                            title="">
                            <div dangerouslySetInnerHTML={{ __html: snippetR }}></div>
                        </AUcallout>
                    </div>
                    : null}

                <div className="au-form-group" >
                    <a className="au-direction-link" href={loc}>
                        <span className="au-direction-link__arrow au-direction-link__arrow--left" />
                        Return to myCASA
                    </a>
                </div>

            </Fragment>
        );
    }
}
